import React, { useState } from 'react'
import View from './View'
import Text from './TextNew'

interface Props {
  imgSrc?: string | null
  onChange: (value: string) => void
}

const AvatarInput = ({ imgSrc, onChange }: Props): JSX.Element => {
  const [fileUrl, setFileUrl] = useState('')
  const emptyLogo = typeof imgSrc !== 'string' && fileUrl.length === 0

  const pickUpFile = (): void => {
    try {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (e): void => {
        const file = (e.target as HTMLInputElement).files?.[0]
        if (typeof file !== 'undefined') {
          const reader = new FileReader()
          reader.onloadend = () => {
            const base64String = reader.result as string
            setFileUrl(URL.createObjectURL(file))
            onChange(base64String)
          }
          reader.readAsDataURL(file)
        }
      }

      input.click()
    } catch (err) {}
  }

  return (
    <View className="px-4">
      <View
        className="w-full h-[15rem] rounded-4 object-cover border border-lightGray overflow-hidden cursor-pointer"
        onClick={pickUpFile}>
        {emptyLogo && (
          <View className="w-full h-full bg-lightGray flex items-center justify-center">
            <Text color="black" className="text-xl !text-black text-center font-bold">
              Logo
            </Text>
          </View>
        )}
        {!emptyLogo && (
          <img src={fileUrl.length > 0 ? fileUrl : imgSrc ?? ''} className="w-full h-full object-cover rounded-4" />
        )}
      </View>
    </View>
  )
}

export default AvatarInput
